import { Button } from "@/components/ui/button";
import { Menu, MenuItem, MenuPopover, MenuTrigger } from "@/components/ui/menu";

import { CaretDownIcon, CheckIcon } from "@phosphor-icons/react";

import { cn } from "@/lib/utils";
import { useFeedOptions } from "@/store/news-feeds/news-feeds.selectors";

interface BrandDropdownProps {
  feedId: string | null;
  setFeedId: (feedId: string) => void;
}

const BrandDropdown = ({ feedId, setFeedId }: BrandDropdownProps) => {
  const feedOptions = useFeedOptions();

  const selectedFeedId = feedOptions.find((feed) => feed.feedId === feedId);

  return (
    <div>
      <MenuTrigger>
        <Button
          size={"sm"}
          variant={"outline"}
          className={cn(
            "px-2 font-normal tracking-wide flex w-full justify-between items-center",
            selectedFeedId ? "text-gray-900" : "text-gray-600",
          )}
        >
          {selectedFeedId?.name ? selectedFeedId.name : "Select a brand"}
          <CaretDownIcon
            className={"size-4 text-gray-400 hover:text-gray-600"}
          />
        </Button>
        <MenuPopover className={"w-(--trigger-width) min-h-min"}>
          <Menu>
            {feedOptions.map((option) => (
              <MenuItem
                key={option.feedId}
                className={"text-xs tracking-wide pr-2"}
                onAction={() => setFeedId(option.feedId)}
              >
                {option.name}
                {feedId === option.feedId && (
                  <CheckIcon className={"ml-auto"} />
                )}
              </MenuItem>
            ))}
          </Menu>
        </MenuPopover>
      </MenuTrigger>
    </div>
  );
};

export default BrandDropdown;
